const ENTRIES = [
  {
    icon: "ri-stack-line",
    title: "本周汇总速报",
    desc: "近 7 天事件按日归档",
    num: "48",
    unit: "条",
    accent: true,
  },
  {
    icon: "ri-folder-open-line",
    title: "本月黑料合集",
    desc: "9 月已出 4 周 / 36 期",
    num: "36",
    unit: "期",
    accent: false,
  },
  {
    icon: "ri-refresh-line",
    title: "近期盘点回看",
    desc: "季度大事件复盘清单",
    num: "12",
    unit: "起",
    accent: false,
  },
  {
    icon: "ri-time-line",
    title: "时间线补课",
    desc: "从本周一路倒带",
    num: "2026",
    unit: "年份",
    accent: false,
  },
];

export default function QuickArchive() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="flex items-center gap-3">
            <span className="font-heading text-[22px] md:text-[28px] font-black text-foreground-950">
              快速归档索引
            </span>
            <span className="hidden md:inline-flex text-[13px] text-foreground-400">按需求挑一个入口往下翻</span>
          </h2>
          <a href="#weekly" className="text-sm text-foreground-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap">
            全部资料 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </a>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {ENTRIES.map((e) => (
            <a
              key={e.title}
              href="#weekly"
              className={`group rounded-lg p-4 md:p-5 border transition-colors ${
                e.accent
                  ? "bg-primary-500 border-primary-500 text-background-50 hover:bg-primary-600"
                  : "bg-background-50 border-background-200 hover:border-primary-200 hover:bg-background-100"
              }`}
            >
              <div className="flex items-start justify-between">
                <span
                  className={`w-10 h-10 rounded-md flex items-center justify-center ${
                    e.accent ? "bg-background-50/15" : "bg-secondary-100"
                  }`}
                >
                  <i
                    className={`${e.icon} w-5 h-5 flex items-center justify-center ${
                      e.accent ? "text-background-50" : "text-secondary-800"
                    }`}
                  />
                </span>
                <span
                  className={`font-heading text-3xl font-black leading-none ${
                    e.accent ? "text-accent-200" : "text-primary-200 group-hover:text-primary-500 transition-colors"
                  }`}
                >
                  {e.num}
                  <span className="text-sm font-normal ml-0.5">{e.unit}</span>
                </span>
              </div>
              <h3 className={`mt-4 font-heading text-[16px] md:text-[18px] font-bold ${e.accent ? "text-background-50" : "text-foreground-950"}`}>
                {e.title}
              </h3>
              <p className={`mt-1 text-[12.5px] ${e.accent ? "text-background-100/80" : "text-foreground-400"}`}>{e.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}